import { createGlobalStyle } from 'styled-components';
import 'normalize.css';

const GlobalStyled = createGlobalStyle`
  body {
      font-family: 'IBM Plex Sans', 'IBMPlexSans', -apple-system, BlinkMacSystemFont, 'Segoe UI', sans-serif;
      -webkit-font-smoothing: antialiased;
      -moz-osx-font-smoothing: grayscale;
      &:not(.user-is-tabbing) button:focus {
          outline: none;
      }
      background: #f8fafc;
      overscroll-behavior-y: contain;
      color: #1e293b;
  }

  h1, h2, h3, h4, h5, h6 {
    font-family: 'IBM Plex Sans', 'IBMPlexSans', -apple-system, BlinkMacSystemFont, 'Segoe UI', sans-serif;
  }

.circle {
  height: 300px;
  width: 300px;
  border-radius: 50%;
  position: fixed;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
}

.circle:before,
.circle:after {
  content: "";
  display: block;
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  background-color: #ffffff;
  border-radius: 50%;
}

.circle:before {
  animation: ripple 3s linear infinite;
}

.circle:after {
  animation: ripple 6s linear infinite;
}

@keyframes ripple {
  0% {
    transform: scale(1);
    opacity: 0;
  }
  50% {
    transform: scale(1.3);
    opacity: 0.2;
  }
  75% {
    transform: scale(1.6);
    opacity: 0.1;
  }
  100% {
    transform: scale(1.9);
    opacity: 0;
  }
}

.box {
  height: 250px;
  width: 250px;
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  background: #FFFFFF;
  border-radius: 100%;
  overflow: hidden;
  border: 5px solid #FFFFFF;
  .percent {
    position: absolute;
    left: 0;
    top: 0;
    z-index: 3;
    width: 100%;
    height: 100%;
    display: flex;
    display: -webkit-flex;
    align-items: center;
    justify-content: center;
    color: black;
    flex-direction: column;
  }
  .water {
    position: absolute;
    left: 0;
    top: 0;
    z-index: 2;
    width: 100%;
    height: 100%;
    transform: translate(0, 100%);
    background: #E9EEFF;
    transition: all 0.3s;
    &_wave {
      width: 200%;
      position: absolute;
      bottom: 100%;
      &_back {
        right: 0;
        fill: #E9EEFF;
        animation: wave-back 2s infinite linear;
      }
      &_front {
        left: 0;
        fill: #E9EEFF;
        margin-bottom: -1px;
        animation: wave-front 1s infinite linear;
      }
    }
  }
}

@keyframes wave-front {
  100% {
    transform: translate(-50%, 0);
  }
}

@keyframes wave-back {
  100% {
    transform: translate(50%, 0);
  }
}

`;

export default GlobalStyled;
